import React from 'react'
import { OfferPageDispatchAction } from './offerPageStateReducer'
import noop from 'lib/function/noop'

const OfferPageDispatchContext = React.createContext<React.Dispatch<OfferPageDispatchAction>>(noop)

export default OfferPageDispatchContext
